module.exports = {
    USER_ID: "User Id",
    KYC_STATUS: "Kyc Status",
    DEMAT_ACCOUNT: "Demat Account Type",
    WHATSAPP_OPT_IN: "Whatsapp Opt In",
};
